export function openSidebar() {
  if (typeof document === "undefined") {
    return;
  }

  document.body.style.setProperty("--SideNavigation-slideIn", "1");
  document.body.style.setProperty("overflow", "hidden");
}

export function closeSidebar() {
  if (typeof document === "undefined") {
    return;
  }

  document.body.style.setProperty("--SideNavigation-slideIn", "0");
  document.body.style.removeProperty("overflow");
}

export function toggleSidebar(open?: boolean) {
  if (typeof document === "undefined") {
    return;
  }

  const current = Number(
    getComputedStyle(document.body).getPropertyValue("--SideNavigation-slideIn") || 0,
  );
  const next = typeof open === "boolean" ? Number(open) : current === 1 ? 0 : 1;

  document.body.style.setProperty("--SideNavigation-slideIn", String(next));

  if (next === 1) {
    document.body.style.setProperty("overflow", "hidden");
  } else {
    document.body.style.removeProperty("overflow");
  }
}
